/**
 * Multimedia Layout
 * @param {string} multimediaSelector - Selector for target elements
 */
var Masonry = require('masonry-layout');
var Swiper = require('swiper').default;
import { lockBody, unlockBody } from '../modules/lock-body';
import * as A11yDialog from 'a11y-dialog';
export class MultimediaLayout {
    constructor(public multimediaSelector) {
        const gridCutoff = 9;

        /**
         * Masonry View More Handler
         * @param {bool} isShow - Boolean for showing or hiding extra elements
         * @param {string} container - Container element for media items
         */
        function viewMoreHandler(isShow, container) {
            let masonryItems = container.querySelectorAll('.item-wrapper');
            let masonryInstance = Masonry.data(container);

            if (masonryItems.length > gridCutoff) {
                for (var i = 0; i < masonryItems.length; i++) {
                    if (isShow) {
                        masonryItems[i].classList.remove('visually-hidden');
                        container.classList.add('show-all');
                    } else if (!isShow && i > gridCutoff - 1) {
                        masonryItems[i].classList.add('visually-hidden');
                        container.classList.remove('show-all');
                    }
                }

                // resets the layout for the masonry grid
                masonryInstance.layout();
            }
        }

        function initMasonryGrid(container) {
            if (!container.classList.contains('masonry-wrapper')) {
                container.classList.add('masonry-wrapper');
                var masonryInstance = new Masonry(container, {
                    // options
                    itemSelector: '.item-wrapper',
                    percentPosition: true
                });

                // set up initial view more handler
                viewMoreHandler(false, container);
            }
        }

        function initCarousel(container) {
            if (!container.classList.contains('swiper-wrapper')) {
                container.classList.add('swiper-wrapper');
                var carouselInstance = new Swiper(container.parentElement, {
                    // Swiper parameters
                    init: false,
                    slidesPerView: 1,
                    spaceBetween: 150,
                    slidesPerGroup: 1,
                    speed: 750,
                    watchOverflow: true,
                    autoHeight: true,

                    pagination: {
                        el: '.swiper-pagination',
                        clickable: false,
                        type: 'custom',
                        renderCustom: function(swiper, current, total) {
                            return current + ' of ' + total;
                        }
                    },

                    // Navigation arrows
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                });

                let slideItems = container.querySelectorAll('.item-wrapper');

                for (var i = 0; i < slideItems.length; i++) {
                    slideItems[i].classList.add('swiper-slide');
                    slideItems[i].classList.remove('visually-hidden');

                    // After slide classes are applied init carousel display
                    if (i === slideItems.length - 1) {
                        carouselInstance.init();
                    }
                }
            }
        }

        function destroyMasonry(container) {
            if (container.classList.contains('masonry-wrapper')) {
                let masonryInstance = Masonry.data(container);

                masonryInstance.destroy();
                container.classList.remove('masonry-wrapper');
            }
        }

        function destroyCarousel(container) {
            if (container.classList.contains('swiper-wrapper')) {
                let carouselInstance = container.parentElement.swiper;

                carouselInstance.destroy();
                container.classList.remove('swiper-wrapper');

                let slideItems = container.querySelectorAll('.item-wrapper');

                for (var i = 0; i < slideItems.length; i++) {
                    slideItems[i].classList.remove('swiper-slide');
                }
            }
        }

        function initModal(container) {
            container = container.parentElement.parentElement;

            const mediaModal = container.querySelector('.modal-wrapper');
            const mediaModalInstance = new A11yDialog(mediaModal);
            const mediaModalContent = mediaModal.querySelector('.swiper-wrapper');
            let modalTriggers = container.querySelectorAll('.item-wrapper');
            let modalCarouselInstance;

            if (!mediaModalContent.classList.contains('modal-content-loaded')) {
                mediaModalContent.innerHTML = container.querySelector('.block-body').innerHTML;
                mediaModalContent.classList.add('modal-content-loaded');
            }

            function initModalCarousel() {
                let modalSlideItems = mediaModalContent.querySelectorAll('.item-wrapper');

                for (var i = 0; i < modalSlideItems.length; i++) {
                    modalSlideItems[i].classList.remove('visually-hidden');
                    modalSlideItems[i].classList.add('swiper-slide');
                }

                modalCarouselInstance = new Swiper(mediaModalContent.parentElement, {
                    // Swiper parameters
                    init: true,
                    slidesPerView: 1,
                    spaceBetween: 150,
                    slidesPerGroup: 1,
                    speed: 750,
                    watchOverflow: true,
                    autoHeight: true,

                    pagination: {
                        el: '.multimedia-block .swiper-pagination',
                        clickable: false,
                        type: 'custom',
                        renderCustom: function(swiper, current, total) {
                            return current + ' of ' + total;
                        }
                    },

                    // Navigation arrows
                    navigation: {
                        nextEl: '.multimedia-block .swiper-button-next',
                        prevEl: '.multimedia-block .swiper-button-prev'
                    }
                });
            }

            mediaModalInstance.on('show', (dialog, e) => {
                lockBody();
            });

            mediaModalInstance.on('hide', function(dialog, e) {
                unlockBody();
                modalCarouselInstance.destroy();
            });

            for (var i = 0; i < modalTriggers.length; i++) {
                let index = i;

                modalTriggers[i].addEventListener('click', e => {
                    if (window.matchMedia('(min-width: 48rem)').matches) {
                        mediaModalInstance.show();
                        initModalCarousel();
                        modalCarouselInstance.slideTo(index, 0);
                    }
                });
            }
        }

        // Handler for different display modes based on screen size
        function initHandler(container) {
            initModal(container);

            if (window.matchMedia('(max-width: 48rem)').matches) {
                destroyMasonry(container);
                initCarousel(container);
            } else {
                destroyCarousel(container);
                initMasonryGrid(container);
            }
        }

        // Initialize Multimedia Block
        if (document.querySelector(multimediaSelector)) {
            let multimediaContainers = document.querySelectorAll(multimediaSelector);

            window.addEventListener('load', () => {
                for (var i = 0; i < multimediaContainers.length; i++) {
                    let multimediaContainer = multimediaContainers[i];

                    initHandler(multimediaContainer);

                    window.addEventListener('resize', () =>
                        window.requestAnimationFrame(() => {
                            initHandler(multimediaContainer);
                        })
                    );

                    let viewMoreTrigger = multimediaContainer.parentElement.querySelector('.multimedia-block-view-more');
                    let masonryItems = multimediaContainer.querySelectorAll('.item-wrapper');

                    if (masonryItems.length > gridCutoff) {
                        viewMoreTrigger.addEventListener('click', e => {
                            if (multimediaContainer.classList.contains('show-all')) {
                                viewMoreHandler(false, multimediaContainer);
                                e.target.innerText = 'View More';
                            } else {
                                viewMoreHandler(true, multimediaContainer);
                                e.target.innerText = 'View Less';
                            }
                        });
                    } else {
                        viewMoreTrigger.parentElement.classList.add('hide-view-more');
                    }
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/multimedia-layout.ts